var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.625 13.1245L13.6728 13.1012C13.8224 13.0264 13.9903 12.9961 14.1566 13.0139C14.3229 13.0316 14.4806 13.0966 14.6111 13.2012C14.7416 13.3058 14.8394 13.4456 14.8929 13.604C14.9464 13.7624 14.9534 13.9329 14.913 14.0952L14.087 17.4038C14.0463 17.5662 14.0531 17.7368 14.1065 17.8955C14.1599 18.0541 14.2576 18.1941 14.3882 18.2989C14.5187 18.4036 14.6766 18.4687 14.843 18.4865C15.0094 18.5042 15.1775 18.4739 15.3272 18.399L15.375 18.3745M25 13.9995C25 15.3784 24.7284 16.7438 24.2007 18.0177C23.6731 19.2916 22.8996 20.4491 21.9246 21.4241C20.9496 22.3991 19.7921 23.1726 18.5182 23.7002C17.2443 24.2279 15.8789 24.4995 14.5 24.4995C13.1211 24.4995 11.7557 24.2279 10.4818 23.7002C9.20791 23.1726 8.05039 22.3991 7.07538 21.4241C6.10036 20.4491 5.32694 19.2916 4.79926 18.0177C4.27159 16.7438 4 15.3784 4 13.9995C4 11.2147 5.10625 8.54402 7.07538 6.57489C9.04451 4.60576 11.7152 3.49951 14.5 3.49951C17.2848 3.49951 19.9555 4.60576 21.9246 6.57489C23.8938 8.54402 25 11.2147 25 13.9995ZM14.5 9.62451H14.5093V9.63385H14.5V9.62451Z",
    stroke: "#181818",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.94aa1bb2071ef1d8d3c71e050e338248.svg";
export { ForwardRef as ReactComponent };